import React from 'react';

import FrameDetailsListItem from 'features/Frames/components/FrameDetailsListItem';
import { Frame } from 'features/Frames/types';
import { createFrameDetailsRows } from 'features/Frames/utils/createFrameDetailsRows';

import useStyles from './FrameDetailsList.styles';

type FrameDetailsListProps = {
  currentFrame: Omit<Frame, 'status'>;
};

const FrameDetailsList = ({ currentFrame }: FrameDetailsListProps) => {
  const classes = useStyles();

  const { frameDetailsFirstRow, frameDetailsSecondRow } = createFrameDetailsRows(currentFrame);

  return (
    <>
      <div className={classes.text}>
        {frameDetailsFirstRow.map(({ prefix, detail, nextDetail }, index) => (
          <FrameDetailsListItem
            key={index}
            prefix={prefix}
            frameDetail={detail}
            nextFrameDetail={nextDetail}
          />
        ))}
      </div>
      <div className={classes.text}>
        {frameDetailsSecondRow.map(({ prefix, detail, nextDetail }, index) => (
          <FrameDetailsListItem
            key={index}
            prefix={prefix}
            frameDetail={detail}
            nextFrameDetail={nextDetail}
          />
        ))}
      </div>
    </>
  );
};

export default FrameDetailsList;
